// API Reference: https://www.wix.com/velo/reference/api-overview/introduction
// “Hello, World!” Example: https://learn-code.wix.com/en/article/1-hello-world
import wixData from "wix-data"
import wixLocation from "wix-location"

$w.onReady(function () {
	$w('#repeater1').collapse()
});


async function search(text) {
	
	$w('#dataset1').setFilter(wixData.filter()
	.contains("name", text)
	//For some reason this .contains causes a network timeout error 
	.or(
		wixData.filter()
		.contains("description", text)
	)
	.or(
		wixData.filter()
		.eq("sku", text)
	)).then(()=>{
		$w('#repeater1').expand()
	})

	/*
	// try to query everything
	// if an error rises just use a normal filter
	try{
		let data1 = wixData.query("Stores/Products")
			.contains("name", text)
			.find()
		let data2 = wixData.query("Stores/Products")
			.contains("description", text)
			.find()
		let data3 = wixData.query("Stores/Products")
			.eq("sku", text)
			.find()
		//let data4 = wixData.query("Stores/Products")
		//	.contains("additionalInfoSections", text)
		//	.find() 
		let results = (await Promise.all([data1,data2,data3])).map(r=>r["items"]).reduce((prev,next)=>prev.concat(next),[])
		let distinct = {}
		for (let r of results) {
			if (!distinct[r._id]) {
				distinct[r._id] = r
			}
		}
		showRelatedProducts(Object.values(distinct))
	}
	catch (e){
		console.log(e)
		/* console.log("error, moving to filter")
		$w('#dataset1').setFilter(wixData.filter()
		.contains("name", text)
		.or(
			wixData.filter()
			.eq("sku", text)
		)).then(()=>{
			$w('#repeater1').expand()
		}) 
	}*/
}


async function relatedItemReady($w, product) {
	$w('#text105').src = product.name;
	$w('#text107').html = product.description;
	$w('#image11').text = product.mainMedia;
	 $w('#text105').onClick(() => {
        wixLocation.to(product.productPageUrl);
    })
}

async function showRelatedProducts(products) {
	if (products.length > 0) {
		$w('#repeater1').onItemReady(relatedItemReady)
		$w('#repeater1').data = products
		$w('#repeater1').expand()
	} else {
		$w('#repeater1').collapse()
	}
}

let lastTimeout = -1;

export function input14_input(event) {
	if (lastTimeout >= 0) {
		clearTimeout(lastTimeout)
	}
	// wait 2 seconds for the user to finish typing before calling the function
	lastTimeout = setTimeout(function() {
		let text = $w('#input14').value
		search(text)
		lastTimeout = -1;
	}, 1000);
	
}